import React from 'react'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import MainCta from '../botones/main-cta'
import Multicanalidad from '../botones/multicanalidad'
import Casa from '../../../static/images/bac-objetivos/bac-objetivos-icon-1.svg'

const Container = styled.div`
  background: ${props => props.theme.colors.grisClaro};
  background:#eae9eb;
  position: relative;
  text-align: center;
  margin: 0 auto;

  h1 {
    font-size: 2em;
    margin: 0 0 0.3em;
  }

  h2 {
    font-size: 1.2em;
    font-weight: 400;
    color: ${props => props.theme.colors.grisOscuro};
    margin: 0 0 0.5em;
  }

  h3 {
    font-weight: 400;
  }

  p {
    color: ${props => props.theme.colors.grisOscuro};
    margin-bottom: 0 0 1.5em;
  }

  ${breakpoint('desktop')`
    h1{
      font-size: 2.2em;
    }

    h2{
      font-size: 2em;
    }

    a {
      font-size: 1.3em;
    }
  `}

  video {
    max-width: 100%;
  }
`

const Wrapper = styled.div`
  padding: 3em 2em;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  box-sizing: border-box;

  ${breakpoint('tablet')`
    display: flex;
    text-align: left;
    justify-content: center;

    & > div {
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: 50%;
      max-width: 600px;
      box-sizing: border-box;
    }

    & > div:first-of-type {
      padding-right: 20px;
    }
  `}
`

const ImageHipo = styled.img `
    width: 400px;
    margin: 25px auto;
    display: block;

    ${breakpoint('tablet')`
        margin: 10px auto;
    `}
        
`

const Header = ({ formUrl, multicanalidad, pais }) => (
  <Container>
    <Wrapper>
      <div>
        {/* <h1>
          Solicit{["CRI", "NIC"].includes(pais.contryAbr) ? "á" : "a"} tu
          tarjeta
        </h1> */}
        <h1 style={{fontWeight: 600}}>Abrí tu Cuenta Objetivos</h1>
        <h1 style={{fontWeight: 600}}>desde Banca en Línea</h1>
        <h3>Cuenta Objetivos es un ahorro programado que se rebaja de tu cuenta BAC Credomatic y te ayuda a cumplir tus metas.</h3>
        {/* <h2>Fácil. Rápido. Seguro.</h2> */}
        {multicanalidad == null ? (
          <MainCta to={formUrl}>
            Llen{["CRI", "NIC"].includes(pais.contryAbr) ? "á" : "a"} el
            formulario
          </MainCta>
        ) : (
          <Multicanalidad multicanalidad={multicanalidad} />
        )}
        {/* <p>
          Y {["CRI", "NIC"].includes(pais.contryAbr) ? "recibila" : "recíbela"}{" "}
          en tu casa u oficina
        </p> */}
      </div>
      <div>
          <div>
            <ImageHipo alt="Cuentas Objetivos" src={Casa}></ImageHipo>
          </div>
      </div>
    </Wrapper>
  </Container>
);

export default Header